import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// Admin
import _adminGbCommon from '../pages/admin/i18n/locales/en/gb/common-translations-gb.json'
import _adminGbTrans from '../pages/admin/i18n/locales/en/gb/translations.json'
import _adminUsCommon from '../pages/admin/i18n/locales/en/us/common-translations-us.json'
import _adminUsTrans from '../pages/admin/i18n/locales/en/us/translations.json'
import _custGbCommon from '../pages/customers/i18n/locales/en/gb/common-translations-gb.json'
// Customers
import _custGbTrans from '../pages/customers/i18n/locales/en/gb/translations.json'
import _custUsCommon from '../pages/customers/i18n/locales/en/us/common-translations-us.json'
import _custUsTrans from '../pages/customers/i18n/locales/en/us/translations.json'
import _dmGbCommon from '../pages/data-management/i18n/locales/en/gb/common-translations-gb.json'
// Data Management
import _dmGbTrans from '../pages/data-management/i18n/locales/en/gb/translations.json'
import _dmUsCommon from '../pages/data-management/i18n/locales/en/us/common-translations-us.json'
import _dmUsTrans from '../pages/data-management/i18n/locales/en/us/translations.json'
import _qtGbCommon from '../pages/quotation-tool/i18n/locales/en/gb/common-translations-gb.json'
// Quotation Tool
import _qtGbTrans from '../pages/quotation-tool/i18n/locales/en/gb/translations.json'
import _qtUsCommon from '../pages/quotation-tool/i18n/locales/en/us/common-translations-us.json'
import _qtUsTrans from '../pages/quotation-tool/i18n/locales/en/us/translations.json'
import _shellGbCommon from './locales/en/gb/common-translations-gb.json'
// Shell
import _shellGbTrans from './locales/en/gb/translations.json'
import _shellUsCommon from './locales/en/us/common-translations-us.json'
import _shellUsTrans from './locales/en/us/translations.json'

type TranslationObject = Record<string, unknown>

function deepMerge(...sources: TranslationObject[]): TranslationObject {
  return sources.reduce<TranslationObject>((acc, src) => {
    for (const [k, v] of Object.entries(src)) {
      if (
        v !== null &&
        typeof v === 'object' &&
        !Array.isArray(v) &&
        typeof acc[k] === 'object' &&
        acc[k] !== null
      ) {
        acc[k] = deepMerge(acc[k] as TranslationObject, v as TranslationObject)
      } else {
        acc[k] = v
      }
    }
    return acc
  }, {})
}

const gbTranslations = deepMerge(
  _shellGbTrans,
  _shellGbCommon,
  _adminGbTrans,
  _adminGbCommon,
  _custGbTrans,
  _custGbCommon,
  _dmGbTrans,
  _dmGbCommon,
  _qtGbTrans,
  _qtGbCommon
)

const usTranslations = deepMerge(
  _shellUsTrans,
  _shellUsCommon,
  _adminUsTrans,
  _adminUsCommon,
  _custUsTrans,
  _custUsCommon,
  _dmUsTrans,
  _dmUsCommon,
  _qtUsTrans,
  _qtUsCommon
)

const preferredRegion = localStorage.getItem('preferredRegion') ?? 'en-GB'
const lng = preferredRegion === 'en-US' ? 'us' : 'en'

i18n.use(initReactI18next).init({
  // biome-ignore lint/style/useNamingConvention: i18n library requirement
  defaultNS: 'translations',
  fallbackLng: 'en',
  lng,
  ns: ['translations'],
  resources: {
    en: { translations: gbTranslations },
    us: { translations: usTranslations }
  },
  returnNull: false,
  interpolation: { escapeValue: false }
})

i18n.languages = ['en', 'us']

export { i18n }
